import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { routes } from "../../routes/routes";
import { ViewMode } from "../../redux/actions/user/userAction";
import { Check } from "react-feather";
import "../../assets/scss/components/_upgrade-overlay.scss";

interface IUpgradeOverlayProps {
	viewMode: ViewMode;
	className?: string;
}

/**
 * UpgradeOverlay Component
 * Displays upgrade prompt when user doesn't have subscription
 * Shows over faded content to encourage subscription
 */
const UpgradeOverlay: React.FC<IUpgradeOverlayProps> = ({ viewMode, className = "" }) => {
	const viewModeLabel = viewMode === "supplier" ? "Supplier" : "Manufacturer";

	return (
		<div className={`upgrade-overlay ${className}`}>
			<div className="upgrade-overlay-content">
				<div className="upgrade-overlay-icon">
					<Check size={48} color="#3f65f1" />
				</div>
				<h3 className="upgrade-overlay-title">Upgrade Required</h3>
				<p className="upgrade-overlay-message">
					Subscribe to view {viewModeLabel} data and unlock all features
				</p>
				<Link to={routes.BILLING}>
					<Button className="upgrade-overlay-button" color="primary">
						<Check size={16} />
						<span>View Subscription Plans</span>
					</Button>
				</Link>
			</div>
		</div>
	);
};

export default UpgradeOverlay;

